import { Row } from './Ui';
import { currency } from '../utils/format';

/**
 * The tax line and admin's extra charges on a bill - a cart, an order, a
 * booking or a stay. Nothing is drawn when there is nothing to pay on top.
 */
const ChargeRows = ({ doc }) => {
  if (!doc) return null;
  const extras = (doc.extras || []).filter((e) => e && e.amount > 0);
  return (
    <>
      {doc.taxes > 0 ? (
        <Row label={`${doc.taxLabel || 'Tax'}${doc.taxPercent ? ` (${doc.taxPercent}%)` : ''}`} value={currency(doc.taxes)} />
      ) : null}
      {extras.map((e, i) => <Row key={`${e.label}-${i}`} label={e.label} value={currency(e.amount)} />)}
    </>
  );
};

export default ChargeRows;
